import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, HostListener, AfterViewInit, Input, QueryList, ViewChild, NgZone, OnChanges, SimpleChanges } from '@angular/core';

import { SlickComponent } from 'ngx-slick';

import { Network } from '@shared/data';

@Component({
  moduleId: 'module.id',
  selector: 'network-slider',
  styles: [require('./network-slider.component.scss')],
  template: require('./network-slider.component.html')
})
export class NetworkSliderComponent implements OnInit, AfterViewInit {
  @Input()
  public networks: Network[];

  @Input()
  public lang: string;

  @ViewChild('slider')
  public slider: SlickComponent;

  public currentSlide: number;

  public slideCount: number;

  public config: any = {
    infinite: false,
    slidesToScroll: 5,
    slidesToShow: 5,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToScroll: 3,
          slidesToShow: 3,
        }
      }
    ]
  }

  constructor(private zone: NgZone) {

  }

  // ===============================================================================================
  // Override Methods
  // ===============================================================================================

  public ngOnInit() {

  }

  public ngAfterViewInit() {

  }

  // ===============================================================================================
  // Actions
  // ===============================================================================================

  public onAfterChange(evt: any) {
    this.currentSlide = evt.currentSlide;
    this.slideCount = evt.slick.slideCount - evt.slick.options.slidesToShow - 1;
  }

  public onPrev() {
    this.slider.slickPrev();
  }

  public onNext() {
    this.slider.slickNext();
  }

  public onReady() {
    this.slider.initSlick();
    this.currentSlide = 0;
    this.slideCount = this.slider.$instance[0].slick.slideCount - this.slider.$instance[0].slick.options.slidesToShow - 1;
  }
}




// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+web/modules/+home/network-slider/network-slider.component.ts